import React from 'react';
import { Box } from '@mui/material';
import { ConnectedMonitoringScreen } from '../../../Monitoring/ConnectedMonitoringScreen';

export function DeviceMonitoringPage() {
  return (
    <Box sx={{ mb: 2 }}>
      <ConnectedMonitoringScreen />
    </Box>
  );
}
